import React, { useEffect, useState } from 'react';
import { Loader2 } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';
import { StrategyReportButtons } from '../crm/StrategyReportButtons';

const APR = { favorable: 'Favorable', incierta: 'Incierta', desfavorable: 'Desfavorable' };

// Admin: every case with an approved strategy, from all lawyers, with PDF/Word download
export const AdminStrategyReports = () => {
  const { api } = useAuth();
  const [rows, setRows] = useState(null);
  const [q, setQ] = useState('');
  useEffect(() => { api.get('/crm/admin/strategy-reports').then((r) => setRows(r.data.matters)).catch(() => setRows([])); }, []); // eslint-disable-line react-hooks/exhaustive-deps
  if (!rows) return <p className="flex items-center gap-2 text-sm text-slate-400"><Loader2 className="h-4 w-4 animate-spin" />Cargando casos...</p>;
  const shown = rows.filter((r) => `${r.title} ${r.lawyer} ${r.court || ''}`.toLowerCase().includes(q.toLowerCase()));
  return (
    <div data-testid="admin-strategy-reports" className="space-y-3">
      <input data-testid="admin-strategy-search" value={q} onChange={(e) => setQ(e.target.value)} placeholder="Buscar por caso, abogado o tribunal" className="w-full max-w-md rounded-lg border border-slate-700 bg-slate-900 px-3 py-2 text-sm text-white" />
      {shown.length === 0 && <p className="text-sm text-slate-400">No hay casos con estrategia aprobada.</p>}
      {shown.map((r) => (
        <div key={r.id} data-testid={`admin-strategy-row-${r.id}`} className="flex flex-wrap items-center justify-between gap-3 rounded-xl border border-slate-800 bg-slate-900 p-3">
          <div className="min-w-0">
            <p className="truncate text-sm font-semibold text-white">{r.title}</p>
            <p className="text-xs text-slate-400">{r.lawyer} · {r.court || 'sin tribunal'} · {r.matter_type} · v{r.intake_strategy?.version || 1} · {APR[r.intake_strategy?.content?.apreciacion] || 'Incierta'} · {String(r.intake_strategy?.reviewed_at || '').slice(0, 10)}</p>
          </div>
          <StrategyReportButtons matterId={r.id} title={r.title} testid={`admin-strategy-report-${r.id}`} />
        </div>
      ))}
    </div>
  );
};
